import AnalysisTaskConstants from "./AnalysisTaskConstants.js";
function resubmitTask(workspaceId, taskId, scorecardId, modifiedBy) {
  return {
    type: AnalysisTaskConstants.RESUBMIT_TASK,
    payload: {
      WorkspaceId: workspaceId,
      TaskIds: [taskId],
      ScorecardId: scorecardId,
      ModifiedBy: modifiedBy
    }
  };
}
function resubmittingTask() {
  return {
    type: AnalysisTaskConstants.RESUBMITTING_TASK
  };
}
function resubmittedTask() {
  return {
    type: AnalysisTaskConstants.RESUBMITTED_TASK
  };
}
function cancelTask(workspaceId, taskId, scorecardId, modifiedBy) {
  return {
    type: AnalysisTaskConstants.CANCEL_TASK,
    payload: {
      WorkspaceId: workspaceId,
      TaskIds: [taskId],
      ScorecardId: scorecardId,
      ModifiedBy: modifiedBy
    }
  };
}
function cancellingTask() {
  return {
    type: AnalysisTaskConstants.CANCELLING_TASK
  };
}
function cancelledTask() {
  return {
    type: AnalysisTaskConstants.CANCELLED_TASK
  };
}
function resetTaskActions() {
  return {
    type: AnalysisTaskConstants.RESET_TASK_ACTIONS
  };
}
export {
  cancelTask,
  cancelledTask,
  cancellingTask,
  resetTaskActions,
  resubmitTask,
  resubmittedTask,
  resubmittingTask
};
//# sourceMappingURL=AnalysisTaskActions.js.map
